import {
  DeliveryTypeEnum,
  SmopOrderStatusEnum,
  SmopUserTypeCode
} from "@saleor/types/globalTypes";

export const hasPermission = (
  order: {
    deliveryType?: DeliveryTypeEnum;
    status?: SmopOrderStatusEnum;
    userType?: SmopUserTypeCode;
  },
  deliveryTypes: DeliveryTypeEnum[] | null,
  statuses: SmopOrderStatusEnum[] | null,
  users: SmopUserTypeCode[] | null,
  loading: boolean
) => {
  const { deliveryType, status, userType } = order;

  const checkDeliveryType =
    deliveryType && deliveryTypes ? deliveryTypes.includes(deliveryType) : true;
  const checkStatus = status && statuses ? statuses.includes(status) : true;
  const checkUser = userType && users ? users.includes(userType) : true;
  return checkDeliveryType && checkStatus && checkUser && !loading;
};
